<template>
  <div class="riskgo">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="外部交易号">
          <el-input v-model="filter.alipayTradeNos" placeholder="请输入外部交易号"></el-input>
        </el-form-item>
        <el-form-item label="所属平台">
          <el-select v-model="filter.companyId" placeholder="请选择所属平台">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推送时间">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="平台订单号">
          <el-input v-model="filter.orderNumber" placeholder="请输入平台订单号"></el-input>
        </el-form-item>
        <el-form-item label="风险类型">
          <el-select v-model="filter.risktype" placeholder="请选择风险类型">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in riskList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户投诉时间">
          <el-date-picker
            v-model="dateList1"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="处理进度">
          <el-select v-model="filter.processStatus" placeholder="请选择处理进度">
            <el-option label="全部" value=""></el-option>
            <el-option label="未处理" value="1"></el-option>
            <el-option label="已处理" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model="filter.phone" placeholder="请输入用户手机号"></el-input>
        </el-form-item>
        <el-form-item label="商户主体">
          <el-input v-model="filter.mchBody" placeholder="请输入商户主体"></el-input>
        </el-form-item>
        <el-form-item label="商户号">
          <el-input v-model="filter.mchId" placeholder="请输入商户号"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="exportRisk">导出</el-button>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card style="margin-top: 10px;">
      <el-table :data="list" border style="margin-top: 10px">
        <el-table-column align="center" label="外部订单号" prop="alipayTradeNos" width="150"></el-table-column>
        <el-table-column align="center" label="平台订单号" prop="orderNumber" width="150"></el-table-column>
        <el-table-column align="center" label="投诉次数" prop="riskNum" width="110"></el-table-column>
        <el-table-column align="center" label="商户主体" prop="mchBody" width="140"></el-table-column>
        <el-table-column align="center" label="商户号" prop="mchId" width="140"></el-table-column>
        <el-table-column align="center" label="所属平台" prop="companyName" width="80"></el-table-column>
        <el-table-column align="center" label="风险类型" prop="risktype" width="80"></el-table-column>
        <el-table-column align="center" label="风险情况描述" prop="risklevel" width="150"></el-table-column>
        <el-table-column align="center" label="用户手机号" prop="phone" width="110"></el-table-column>
        <el-table-column align="center" label="推送时间" prop="insertDate" width="100"></el-table-column>
        <el-table-column align="center" label="用户投诉时间" prop="complainTime" width="110"></el-table-column>
        <el-table-column align="center" label="用户投诉内容" prop="complainText" width="300">
          <template slot-scope="scope">
            <template v-if="scope.row.complainText">
              <div v-if="scope.row.complainText.length < 100">{{ scope.row.complainText }}</div>
              <el-tooltip v-else class="item" effect="dark" popper-class="tooltip" placement="top">
                <div slot="content" class="tooltip">{{ scope.row.complainText }}</div>
                <!-- <div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{ scope.row.applyType === 1 ? scope.row.applyExplain : scope.row.repairPrintExplain }}</div> -->
                <div>{{ scope.row.complainText.substr(0,100) }}...</div>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="处理进度" prop="processStatus" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.processStatus === 1">未处理</span>
            <span v-if="scope.row.processStatus === 2">已处理</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="processExplain" width="">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
              <div slot="content" class="tooltip">{{ scope.row.processExplain }}</div>
              <div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{ scope.row.processExplain }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="" width="100" fixed="right">
          <template slot-scope="scope">
            <a v-if="scope.row.processStatus === 1" style="color: #f00 !important;" href="javascript:;" @click="processRisk(scope.row)">处理风控</a>
            <a v-if="scope.row.processStatus === 2" href="javascript:;" @click="processDetail(scope.row)">处理详情</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      title="处理风控"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose">

      <el-form style="margin-top: 20px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="处理结果" prop="processCode">
          <el-select v-model="ruleForm.processCode" placeholder="请选择">
            <el-option value="07" label="平台进行退款退订"></el-option>
            <el-option value="08" label="平台跟用户沟通后，用户撤诉"></el-option>
            <el-option value="06" label="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理沟通证明" prop="">
          <div class="pic" style="" v-for="(item, i) in picList" :key="item">
            <i class="el-icon-delete" @click="picList.splice(i, 1)"></i>
            <img style="width: 60px; height: 60px" :src="item" alt="">
          </div>
          <ImgUpload accept=".JPG, .jpg, .png, .PNG, .jpeg, .JPEG" :max="9" @input="pic"></ImgUpload>
        </el-form-item>
        <el-form-item label="备注说明" prop="processExplain">
          <el-input v-model="ruleForm.processExplain" type="textarea" :rows="3" maxlength="1000" show-word-limit size="small" placeholder="请输入备注说明"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="" size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="updateRiskgoRecord">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="处理详情"
      :visible.sync="dialogVisible1"
      width="600px"
      :before-close="handleClose1">

      <el-button type="primary" size="small" @click="processRisk(rowDetail)">更新风控处理</el-button>
      <el-table :data="list1" border style="margin-top: 10px">
        <el-table-column align="center" label="处理人" prop="insertName"></el-table-column>
        <el-table-column align="center" label="处理结果" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.processCode === '07'">平台进行退款退订</span>
            <span v-if="scope.row.processCode === '08'">平台跟用户沟通后，用户撤诉</span>
            <span v-if="scope.row.processCode === '06'">其他</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="处理时间" prop="insertDate"></el-table-column>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a :disabled="!scope.row.processImg && !scope.row.processExplain" href="javascript:;" @click="openDia(scope.row)">处理详情内容</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter1.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter1.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleClose1">确定</el-button>
      </span>
    </el-dialog>

    <Detail ref="Detail" />
  </div>
</template>

<script>
import { getAvailableCompanyList, getRiskGoList, updateRiskgoRecord, getListPageProcess } from '@/api/admin/riskgo.js'
import ImgUpload from '@/components/upload/file'
import Detail from './components/detail.vue'
import { downloadData } from '@/api/common'

const riskList = [
  '赌博',
  '欺诈',
  '坏账',
  '集资',
  '色情',
  '套现',
  '花呗套现',
  '虚拟币',
  '投诉',
  '虚假交易',
  '优惠费率滥用',
  '代扣投诉',
  '小程序交易纠纷',
  '撤诉结案',
]
export default {
  name: 'riskgo',
  components: { ImgUpload, Detail },
  data () {
    return {
      riskList,
      filter: {
        page: 1,
        limit: 10,
        alipayTradeNos: '',
        companyId: '',
        orderNumber: '',
        risktype: '',
        processStatus: '',
        phone: '',
        pushStartDate: '',
        pushEndDate: '',
        riskStartDate: '',
        riskEndDate: '',
        mchBody: '',
        mchId: ''
      },
      total: 0,
      list: [],
      companyList: [],
      dialogVisible: false,
      row: null,
      ruleForm: {
        processCode: '',
        processExplain: ''
      },
      rules: {
        processCode: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      picList: [],
      dialogVisible1: false,
      rowDetail: null,
      filter1: {
        page: 1,
        limit: 10
      },
      list1: [],
      total1: 0
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.pushStartDate, this.filter.pushEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.pushStartDate = v[0] + ' 00:00:00' || ''
          this.filter.pushEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.pushStartDate = ''
          this.filter.pushEndDate = ''
        }
      }
    },
    dateList1: {
      get() {
        return [this.filter.riskStartDate, this.filter.riskEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.riskStartDate = v[0] + ' 00:00:00' || ''
          this.filter.riskEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.riskStartDate = ''
          this.filter.riskEndDate = ''
        }
      }
    }
  },
  created() {
    this.getAvailableCompanyList()
    this.getList()
  },
  methods: {
    async getAvailableCompanyList() {
      const res = await getAvailableCompanyList()
      this.companyList = res.data
    },
    async getList () {
      const res = await getRiskGoList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    updateRiskgoRecord() {
      this.$refs['ruleForm'].validate(async(valid) => {
        if (valid) {
          const res = await updateRiskgoRecord({ id: this.row.id, ...this.ruleForm, processImg: this.picList.join() })
          this.$message.success('操作成功！')
          this.handleClose()
          this.getListPageProcess()
          this.getList()
        }
      })
    },
    async getListPageProcess() {
      const res = await getListPageProcess({ riskgoId: this.rowDetail.id, ...this.filter1 })
      this.list1 = res.data.records
      this.total1 = +res.data.total
    },
    exportRisk() {
      let data = ''
      const filter = {...this.filter }
      delete filter.page
      delete filter.limit
      downloadData(
        `/order/adm/riskgoRecord/export${data}`,
        filter,
        '风控处理列表'
      )
    },
    pic(url) {
      if (this.picList.length < 9) {
        this.picList.push(url)
      } else {
        this.$message.error('最多能上传9张哦')
      }
    },
    openDia(row) {
      this.$refs.Detail.init(row)
    },
    processRisk(row) {
      this.row = row
      this.dialogVisible = true
    },
    processDetail(row) {
      this.rowDetail = row
      this.getListPageProcess()
      this.dialogVisible1 = true
    },
    handleClose1() {
      this.dialogVisible1 = false
      this.rowDetail = null
    },
    handleClose() {
      this.dialogVisible = false
      this.row = null
      this.picList = []
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = ''
      })
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleSizeChange1(v) {
      this.filter1.page = 1
      this.filter1.limit = v
      this.getListPageProcess()
    },
    handleCurrentChange1(v) {
      this.filter1.page = v
      this.getListPageProcess()
    },
  }
}
</script>

<style lang="scss" scoped>
.riskgo {
  ::v-deep .pic {
    display: inline-block;
    width: 60px;
    height: 60px;
    position: relative;

    i {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background-color: #ccc;
      font-size: 26px;
      opacity: .8;
      cursor: pointer;
    }

    &:hover {
      i {
        display: inline-block;
      }
    }
  }
}

.tooltip {
  width: 500px !important;
}
</style>
